// extracted by mini-css-extract-plugin
export var linkText = "_oz-0";